import { isFriday } from 'date-fns';
import { eachDayOfInterval, startOfDay } from 'date-fns/esm/fp';

const createDate = date => startOfDay(new Date(date));

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}
const getContinuousDaysInRange = (min, max) => {
  if (!isValidDate(min) || !isValidDate(max)) return [];
  return eachDayOfInterval({ start: min, end: max }).map(date =>
    startOfDay(date)
  );
};

// Get all days in an year (like tuesdays of 2025, fridays of 2025 etc. in the below format with return type same as createDate function)
const getDaysInYear = (year, dayOfWeek) => {
  const start = new Date(year, 0, 1);
  const end = new Date(year, 11, 31);
  const allDays = eachDayOfInterval({ start, end });
  return allDays
    .filter(date => date.getDay() === dayOfWeek)
    .map(date => startOfDay(date));
};

const CATEGORIES = {
  SHARADA: 'Sharada Temple',
  SHIVA: 'Shiva Temple',
  GANESH: 'Ganapathi Temple',
  SPECIAL_EVENTS: 'Special Events',
  OTHERS: 'Special General Poojas',
  DASARA_NAVARATRI: 'Dasara Navaratri Poojas',
  GANAPATHI_NAVARATRI: 'Ganapthi Navaratri Poojas',
  MAHASHIVARATRI: 'Maha Shivaratri Special Poojas'
};

export const poojaInfo = [
  // 1) Rudra Abhishekam
  {
    label: 'Rudra Abhishekam',
    name: 'Shiva Abhishekam',
    amount: '150',
    availableDates: [],
    category: CATEGORIES.SHIVA
  },
  // 2) Aksharabhyasam
  {
    label: 'Aksharabhyasam',
    name: 'Aksharabhyasam',
    amount: '100',
    availableDates: [],
    category: CATEGORIES.OTHERS
  },
  // 3) Naivedya Sahasram
  {
    label: 'Naivedya Sahasram',
    name: 'Naivedya Sahasram',
    amount: '100',
    availableDates: [],
    category: CATEGORIES.SHARADA
  },
  // 4) Pushpa Alankara Seva
  {
    label: 'Pushpa Alankara Seva',
    name: 'Pushpa Alankara Seva',
    amount: '500',
    availableDates: [],
    category: CATEGORIES.SHARADA
  },

  // ------------------------------------------------------------------
  // 5) Pradoshabhishekam (Pradosha Puja) - TWO DATES PER MONTH in 2026
  // ------------------------------------------------------------------
  {
    name: 'Pradoshabhishekam',
    amount: '150',
    // 2026 DATES
    availableDates: [
      createDate('01-16-2026'),
      createDate('01-30-2026'),
      createDate('02-14-2026'),
      createDate('02-28-2026'),
      createDate('03-16-2026'),
      createDate('03-30-2026'),
      createDate('04-15-2026'),
      createDate('04-29-2026'),
      createDate('05-14-2026'),
      createDate('05-28-2026'),
      createDate('06-12-2026'),
      createDate('06-27-2026'),
      createDate('07-12-2026'),
      createDate('07-26-2026'),
      createDate('08-10-2026'),
      createDate('08-25-2026'),
      createDate('09-08-2026'),
      createDate('09-24-2026'),
      createDate('10-08-2026'),
      createDate('10-23-2026'),
      createDate('11-06-2026'),
      createDate('11-22-2026'),
      createDate('12-06-2026'),
      createDate('12-21-2026')
    ],
    category: CATEGORIES.SHIVA
  },

  // ------------------------------------------------
  // 6) Ganapathi Homam (Shukla Chavithi) - 2026
  // ------------------------------------------------
  {
    label: 'Ganapathi Homam  (Shukla Chavithi)',
    name: 'Ganapathi Homam',
    amount: '250',
    // 2026 DATES
    availableDates: [
      createDate('12-24-2025'),
      createDate('01-22-2026'),
      createDate('02-21-2026'),
      createDate('03-22-2026'),
      createDate('04-21-2026'),
      createDate('05-20-2026'),
      createDate('06-18-2026'),
      createDate('07-18-2026'),
      createDate('08-16-2026'),
      createDate('09-14-2026'),
      createDate('10-14-2026'),
      createDate('11-13-2026'),
      createDate('12-13-2026')
    ],
    category: CATEGORIES.GANESH,
    information: 'Performed Every month on Shukla Chavithi'
  },

  // 7) Ganapathi Navaratri Homam - 2026 (14-09-2026 to 22-09-2026)
  {
    label: 'Ganapathi Navaratri Homam',
    name: 'Ganapathi Navaratri Homam',
    amount: '250',
    availableDates: [
      ...getContinuousDaysInRange(
        new Date('09-14-2026'),
        new Date('09-22-2026')
      )
    ],
    category: CATEGORIES.GANESH,
    information: 'Performed only in Ganapathy Navaratri days'
  },
  // 8) Sahashra Modaka Ganapathi (unchanged)
  {
    label: 'Sahashra Modaka Ganapathi Homa Sahitha Abhishekam',
    name: 'Sahashra modaka ganapathi homa sahitha abhishekam',
    amount: '300',
    availableDates: [createDate('09-18-2023')],
    category: CATEGORIES.GANESH,
    information:
      'Performed only in Vinayaka Chavithi (Bhadra pada shuddha chaviti)'
  },

  // ---------------------------------------------------------
  // 9) Guru Paduka Pooja (Every Shukla Shasti) - 2026
  // ---------------------------------------------------------
  {
    label: 'Guru Paduka Pooja (Every Shukla Shasti)',
    name: 'Guru Paduka Pooja',
    amount: '300',
    // 2026 DATES
    availableDates: [
      createDate('12-26-2025'),
      createDate('01-24-2026'),
      createDate('02-23-2026'),
      createDate('03-24-2026'),
      createDate('04-22-2026'),
      createDate('05-22-2026'),
      createDate('06-20-2026'),
      createDate('07-20-2026'),
      createDate('08-18-2026'),
      createDate('09-17-2026'),
      createDate('10-16-2026'),
      createDate('11-15-2026'),
      createDate('12-15-2026')
    ],
    category: CATEGORIES.SPECIAL_EVENTS
  },

  // ---------------------------------------------------------
  // 10) Chandi Parayana (Shukla Saptami - Pournami) - 2026
  // ---------------------------------------------------------
  {
    label: 'Parayana / Homam (Shukla Saptami - Pournami)',
    name: 'Chandi Parayana',
    amount: '500',
    availableDates: [
      ...getContinuousDaysInRange(
        new Date('12-27-2025'),
        new Date('01-04-2026')
      ),
      // January 25 – February 1 (Pournami on Feb 1)
      ...getContinuousDaysInRange(
        new Date('01-25-2026'),
        new Date('02-01-2026')
      ),
      // February 24 – March 3 (Pournami on Mar 3)
      ...getContinuousDaysInRange(
        new Date('02-24-2026'),
        new Date('03-03-2026')
      ),
      // March 25 – April 2 (Pournami on Apr 2)
      ...getContinuousDaysInRange(
        new Date('03-25-2026'),
        new Date('04-02-2026')
      ),
      // April 23 – May 1 (Pournami on May 1)
      ...getContinuousDaysInRange(
        new Date('04-23-2026'),
        new Date('05-01-2026')
      ),
      // May 23 – May 31 (Pournami on May 31)
      ...getContinuousDaysInRange(
        new Date('05-23-2026'),
        new Date('05-31-2026')
      ),
      // June 21 – June 29 (Pournami on Jun 29)
      ...getContinuousDaysInRange(
        new Date('06-21-2026'),
        new Date('06-29-2026')
      ),
      // July 21 – July 29 (Pournami on Jul 29)
      ...getContinuousDaysInRange(
        new Date('07-21-2026'),
        new Date('07-29-2026')
      ),
      // August 19 – August 28 (Pournami on Aug 28)
      ...getContinuousDaysInRange(
        new Date('08-19-2026'),
        new Date('08-28-2026')
      ),
      // September 18 – September 26 (Pournami on Sep 26)
      ...getContinuousDaysInRange(
        new Date('09-18-2026'),
        new Date('09-26-2026')
      ),
      // October 17 – October 26 (Pournami on Oct 26)
      ...getContinuousDaysInRange(
        new Date('10-17-2026'),
        new Date('10-26-2026')
      ),
      // November 16 – November 24 (Pournami on Nov 24)
      ...getContinuousDaysInRange(
        new Date('11-16-2026'),
        new Date('11-24-2026')
      ),
      // December 16 – December 24 (Pournami on Dec 24)
      ...getContinuousDaysInRange(
        new Date('12-16-2026'),
        new Date('12-24-2026')
      )
    ],
    category: CATEGORIES.SPECIAL_EVENTS
  },
  // ---------------------------------------------------------
  // 11) Satyanarayana Swamy Vratam - 2026
  // ---------------------------------------------------------
  {
    name: 'Satyanarayana Swamy Vratam',
    amount: '200',
    // 2026 DATES
    availableDates: [
      createDate('12-30-2025'),
      createDate('01-29-2026'),
      createDate('02-27-2026'),
      createDate('03-29-2026'),
      createDate('04-27-2026'),
      createDate('05-27-2026'),
      createDate('06-25-2026'),
      createDate('07-25-2026'),
      createDate('08-23-2026'),
      createDate('09-22-2026'),
      createDate('10-22-2026'),
      createDate('11-20-2026'),
      createDate('12-20-2026')
    ],
    category: CATEGORIES.SPECIAL_EVENTS
  },

  // ---------------------------------------------------------
  // 12) Pournami Laksha Kumukumarchana - 2026
  // ---------------------------------------------------------
  {
    name: 'Pournami Laksha Kumukumarchana',
    amount: '4000',
    // 2026 DATES
    availableDates: [
      createDate('01-03-2026'),
      createDate('02-01-2026'),
      createDate('03-03-2026'),
      createDate('04-02-2026'),
      createDate('05-01-2026'),
      createDate('05-31-2026'),
      createDate('06-29-2026'),
      createDate('07-29-2026'),
      createDate('08-28-2026'),
      createDate('09-26-2026'),
      createDate('10-26-2026'),
      createDate('11-24-2026'),
      createDate('12-24-2026')
    ],
    category: CATEGORIES.SHARADA
  },

  // ---------------------------------------------------------
  // 13) Sankata Hara Chaturdi (Bahula Chavithi) - 2026
  // ---------------------------------------------------------
  {
    label: 'Sankata Hara Chaturdi (Bahula Chavithi)',
    name: 'Sankata Hara Chaturdi',
    amount: '150',
    // 2026 DATES
    availableDates: [
      createDate('01-06-2026'),
      createDate('02-05-2026'),
      createDate('03-06-2026'),
      createDate('04-05-2026'),
      createDate('05-05-2026'),
      createDate('06-03-2026'),
      createDate('07-03-2026'),
      createDate('08-02-2026'),
      createDate('08-31-2026'),
      createDate('09-29-2026'),
      createDate('10-29-2026'),
      createDate('11-27-2026'),
      createDate('12-27-2026')
    ],
    category: CATEGORIES.GANESH
  },

  // ---------------------------------------------------------
  // 14) Masa Sivaratri / Rudra Homam - 2026
  // ---------------------------------------------------------
  {
    label: 'Masa Sivaratri / Rudra Homam',
    name: 'Masa Sivaratri Rudra Homam',
    amount: '300',
    // 2026 DATES
    availableDates: [
      createDate('01-17-2026'),
      createDate('02-15-2026'),
      createDate('03-17-2026'),
      createDate('04-16-2026'),
      createDate('05-15-2026'),
      createDate('06-13-2026'),
      createDate('07-13-2026'),
      createDate('08-11-2026'),
      createDate('09-09-2026'),
      createDate('10-09-2026'),
      createDate('11-07-2026'),
      createDate('12-07-2026')
    ],
    category: CATEGORIES.SHIVA
  },

  // ---------------------------------------------------------
  // 15) Surya Namasakaramulu - 2026
  // ---------------------------------------------------------
  {
    label: 'Surya Namasakaramulu',
    name: 'Surya Namasakaramulu',
    amount: '300',
    // 2026 DATES
    availableDates: [
      createDate('12-28-2025'),
      createDate('01-25-2026'),
      createDate('02-22-2026'),
      createDate('03-29-2026'),
      createDate('04-26-2026'),
      createDate('05-31-2026'),
      createDate('06-29-2026'),
      createDate('07-26-2026'),
      createDate('08-30-2026'),
      createDate('09-27-2026'),
      createDate('10-25-2026'),
      createDate('11-29-2026'),
      createDate('12-27-2026')
    ],
    category: CATEGORIES.SPECIAL_EVENTS
  },

  // ---------------------------------------------------------
  // The rest remain the same unless your 2025 chart says otherwise
  // ---------------------------------------------------------
  {
    label: 'Dhanurmasa Prasadam',
    name: 'Dhanurmasa Prasadam',
    amount: '500',
    availableDates: [...getContinuousDaysInRange(new Date('12-19-2025'), new Date('01-14-2026'))],
    category: CATEGORIES.SPECIAL_EVENTS,
    disabled: false
  },
  {
    label: 'One day Prasada Kanuka',
    name: 'One day Prasada Kanuka',
    amount: '2500',
    availableDates: [...getContinuousDaysInRange(new Date('12-19-2025'), new Date('01-14-2026'))],
    category: CATEGORIES.SPECIAL_EVENTS,
    disabled: false
  },
  {
    name: 'Ganapathi Abhishekam',
    amount: '150',
    availableDates: [],
    category: CATEGORIES.GANESH
  },
  {
    label: 'Radha Saptami Surya Namaskarams',
    name: 'Radha Saptami Surya Namaskarams',
    amount: '300',
    availableDates: [createDate('01-25-2026')],
    category: CATEGORIES.SPECIAL_EVENTS,
    disabled: true
  },
  {
    label: 'Radha Saptami',
    name: 'Radha Saptami',
    amount: '500',
    availableDates: [createDate('01-25-2026')],
    category: CATEGORIES.SPECIAL_EVENTS,
    disabled: true
  },
  {
    name: 'Laghunyasa Abhishekam',
    amount: '50',
    availableDates: [],
    category: CATEGORIES.SHIVA
  },
  {
    name: 'Shiva Panchamrutha Abhishekam',
    amount: '50',
    availableDates: [],
    category: CATEGORIES.SHIVA
  },
  {
    name: 'Ganapathi Panchamrutha Abhishekam',
    amount: '50',
    availableDates: [],
    category: CATEGORIES.GANESH
  },
  {
    name: 'Shiva Ashtottaram',
    amount: '20',
    availableDates: [],
    category: CATEGORIES.SHIVA
  },
  {
    name: 'Ganapathi Ashtottaram',
    amount: '20',
    availableDates: [],
    category: CATEGORIES.GANESH
  },
  {
    name: 'Ashtottaram',
    amount: '20',
    availableDates: [],
    category: CATEGORIES.SHARADA
  },
  {
    name: 'Swarna Bilwarchana',
    amount: '1500',
    availableDates: [],
    category: CATEGORIES.SHIVA
  },
  {
    name: 'Special Swarna Bilwarchana',
    amount: '3000',
    availableDates: [],
    category: CATEGORIES.SHIVA
  },
  {
    name: 'Special Swarna kamalam',
    amount: '3000',
    availableDates: [],
    category: CATEGORIES.SHARADA,
    disabled: true
  },
  {
    label: 'Sarva Abharana Bhushitha Swarna kamalam',
    name: 'Sarva Abharana Bhushitha Swarna kamalam',
    amount: '6000',
    availableDates: [],
    category: CATEGORIES.SHARADA
  },
  {
    label: 'Trishathi Mala Sahita Sarva Abharana Bhushita Swarna kamalam',
    name: 'Trishathi Swarna kamalam',
    amount: '7500',
    availableDates: [],
    category: CATEGORIES.SHARADA
  },
  {
    label: 'Vahana Pooja',
    name: 'Vahana Pooja',
    amount: '100',
    availableDates: [],
    category: CATEGORIES.OTHERS
  },
  {
    label: 'Sata Rudrabhishekam',
    name: 'Sata Rudrabhishekam',
    amount: '8000',
    availableDates: [
      createDate('10-31-2022'),
      createDate('11-07-2022'),
      createDate('11-14-2022'),
      createDate('11-21-2022'),
      createDate('5-2-2025')
    ],
    category: CATEGORIES.SHIVA
  },
  {
    label: 'Bilwarchana',
    name: 'Bilwarchana',
    amount: '250',
    availableDates: [],
    category: CATEGORIES.SHIVA,
    disabled: true
  },
  {
    name: 'Udayasthamana Pooja',
    amount: '3000',
    availableDates: [],
    category: CATEGORIES.SHARADA
  },
  {
    name: 'Swarna Kamala Pooja',
    amount: '1500',
    availableDates: [],
    category: CATEGORIES.SHARADA
  },
  {
    name: 'Sri Chakrarchana Sarva Pooja',
    amount: '150',
    availableDates: [],
    category: CATEGORIES.SHARADA
  },
  {
    name: 'Sahasram',
    amount: '50',
    availableDates: [],
    category: CATEGORIES.SHARADA
  },
  {
    name: 'Sahasra Modaka Ganapathi Homam and Abhishekam',
    amount: '300',
    availableDates: [],
    category: CATEGORIES.GANAPATHI_NAVARATRI,
    disabled: true
  },
  {
    name: 'Durvarchana',
    amount: '250',
    availableDates: [createDate('09-19-2026')],
    category: CATEGORIES.GANAPATHI_NAVARATRI
  },
  {
    label: 'Ratha Seva Wooden Chariot (Every Friday/Pournami)',
    name: 'Ratha Seva Wooden Chariot',
    amount: '1500',
    availableDates: [],
    category: CATEGORIES.OTHERS,
    disabled: true
  },
  {
    label: 'Ratha Seva Silver Chariot (Every Friday/Pournami)',
    name: 'Ratha Seva Silver Chariot',
    amount: '2000',
    availableDates: [],
    category: CATEGORIES.OTHERS,
    disabled: true
  },
  {
    label: 'Kailasa Gouri Nomu Kanuka',
    name: 'Kailasa Gouri Nomu Kanuka',
    amount: '800',
    availableDates: [],
    category: CATEGORIES.OTHERS
  },
  {
    label: 'Suvasini Pooja',
    name: 'Suvasini Pooja',
    amount: '200',
    availableDates: [],
    category: CATEGORIES.OTHERS,
    disabled: true
  },

  // ----------------------------------------------------------------------
  // *** 2026 Dasara Navaratri *** 10-10-2026 (Mahabhishekam / Mahalaya
  // Amavasya) to 21-10-2026 (Dasara). Chandi Homa Kanuka on 20-10-2026.
  // ----------------------------------------------------------------------
  {
    label: 'Chandi Parayana 1 Day',
    name: 'Parayana One Day',
    amount: '200',
    availableDates: [
      ...getContinuousDaysInRange(
        new Date('10-10-2026'),
        new Date('10-21-2026')
      )
    ],
    category: CATEGORIES.DASARA_NAVARATRI
    // disabled: true
  },
  {
    label: 'Chandi Parayana 9 Days',
    name: 'Parayana Nine Days',
    amount: '1500',
    availableDates: [
      ...getContinuousDaysInRange(
        new Date('10-10-2026'),
        new Date('10-21-2026')
      )
    ],
    category: CATEGORIES.DASARA_NAVARATRI
    // disabled: true
  },
  {
    label: 'Dasara Suvasini Pooja',
    name: 'Dasara Suvasini Pooja',
    amount: '200',
    availableDates: [
      ...getContinuousDaysInRange(
        new Date('10-10-2026'),
        new Date('10-21-2026')
      )
    ],
    category: CATEGORIES.DASARA_NAVARATRI
  },
  {
    label: 'Mahabhishekam (Only on Akshaya Thritiya and Mahalaya Amavasya',
    name: 'Mahabhishekam',
    amount: '12000',
    availableDates: [createDate('10-10-2026')],
    category: CATEGORIES.DASARA_NAVARATRI
    // disabled: true
  },
  {
    label: 'Sarva Seva',
    name: 'Sarva Seva',
    amount: '10000',
    availableDates: [
      ...getContinuousDaysInRange(
        new Date('10-10-2026'),
        new Date('10-21-2026')
      )
    ],
    category: CATEGORIES.DASARA_NAVARATRI
    // disabled: true
  },
  {
    label: 'Dasara Udayastamana Pooja',
    name: 'Dasara Udayastamana Pooja',
    amount: '3000',
    availableDates: [
      ...getContinuousDaysInRange(
        new Date('10-10-2026'),
        new Date('10-21-2026')
      )
    ],
    category: CATEGORIES.DASARA_NAVARATRI
    // disabled: true
  },
  {
    label: 'Dasara Chandi Homa Kanuka',
    name: 'Dasara Chandi Homa Kanuka',
    amount: '500',
    availableDates: [createDate('10-20-2026')],
    category: CATEGORIES.DASARA_NAVARATRI
    // disabled: true
  },
  {
    label:
      'Special Sata Rudrabhishekam (On Mahashivaratri/Shankar Jayanti/ Karthika Masam)',
    name: 'Special SataRudrabhishekam ',
    amount: '15000',
    availableDates: [
      createDate('02-15-2026'),
      createDate('03-08-2024'),
      createDate('02-18-2023'),
      createDate('11-07-2022'),
      createDate('11-14-2022'),
      createDate('11-21-2022')
    ],
    category: CATEGORIES.SPECIAL_EVENTS,
    disabled: true
  },
  // 51) Sita Rama Kalyanam (On Sri Rama Navami) - unchanged
  {
    label: 'Sita Rama Kalyanam (On Sri Rama Navami)',
    name: 'Sri Sita Rama Kalyanam ',
    amount: '500',
    availableDates: [createDate('03-30-2023'), createDate('04-17-2024')],
    category: CATEGORIES.OTHERS,
    disabled: false
  },
  // 52) Sri Sita Rama Abhishekam - unchanged
  {
    label: 'Sri Sita Rama Abhishekam',
    name: 'Sri Sita Rama Abhishekam ',
    amount: '100',
    availableDates: [
      ...getContinuousDaysInRange(
        new Date('03-22-2022'),
        new Date('03-30-2022')
      )
    ],
    category: CATEGORIES.OTHERS,
    disabled: false
  },
  // 53) Sri Sita Rama Abhishekam 10 days - unchanged
  {
    label: 'Sri Sita Rama Abhishekam 10 days',
    name: 'Sri Sita Rama Abhishekam 10 days ',
    amount: '1000',
    availableDates: [createDate('03-22-2023')],
    category: CATEGORIES.OTHERS,
    disabled: false
  },
  // 54) Sri Sita Rama Kalyanam and Anna Prasada Kanuka - unchanged
  {
    label: 'Sri Sita Rama Kalyanam and Anna Prasada Kanuka',
    name: 'Sri Sita Rama Kalyanam and Anna Prasada Kanuka',
    amount: '10000',
    availableDates: [createDate('03-30-2023')],
    category: CATEGORIES.OTHERS,
    disabled: false
  },
  // 55) Grahana Shanthi Homam - unchanged
  {
    label: 'Grahana Shanthi Homam (Only during eclipse)',
    name: 'Grahana Shanthi Pooja',
    amount: '300',
    availableDates: [
      createDate('10-26-2022'),
      createDate('11-09-2022'),
      createDate('09-08-2025')
    ],
    category: CATEGORIES.OTHERS,
    disabled: false
  },
  // 56) Lingodbhava Kala Abhishekam - unchanged
  {
    label: 'Lingodbhava Kala Abhishekam',
    name: 'Lingodbhava Abhishekam',
    amount: '100',
    availableDates: [createDate('02-15-2026')],
    category: CATEGORIES.MAHASHIVARATRI,
    disabled: false
  },
  // 57) Girija Kalyanam - unchanged
  {
    label: 'Girija Kalyanam (Next Day of Shivaratri)',
    name: 'Girija Kalyanam',
    amount: '500',
    availableDates: [createDate('02-16-2026')],
    category: CATEGORIES.MAHASHIVARATRI
  },
  // 58) Swarna Vastra Alankara Seva (Fridays Only) - unchanged
  {
    label: 'Swarna Vastra Alankara Seva (Fridays Only)',
    name: 'Swarna Vastra Alankara Seva',
    amount: '12000',
    availableDates: getContinuousDaysInRange(
      new Date('11-21-2020'),
      new Date('03-31-2021')
    ).filter(date => isFriday(date)),
    category: CATEGORIES.SHARADA
  },
  // 59) Chandi Saptashiti Parayanamu
  {
    label: 'Chandi Saptashiti Parayanamu (On every Tuesday)',
    name: 'Chandi Saptashiti Parayanamu',
    amount: '300',
    availableDates: [
      ...getDaysInYear(2025, 2) // Tuesday
    ],
    category: CATEGORIES.SPECIAL_EVENTS
  },
  // 60) Sri Lakshmi Narayana Hrudayamu Parayana
  {
    label: 'Sri Lakshmi Narayana Hrudayamu Parayana (On every Friday)',
    name: 'Sri Lakshmi Narayana Hrudayamu Parayana',
    amount: '300',
    availableDates: [
      ...getDaysInYear(2025, 5) // Friday
    ],
    category: CATEGORIES.SPECIAL_EVENTS
  },
  {
    label: 'Sri Lalitha Homam',
    name: 'Sri Lalitha Homam',
    amount: '500',
    availableDates: [
      createDate('01-23-2026')
    ],
    category: CATEGORIES.SPECIAL_EVENTS
  }
];
